const Banner = ({text,image, position}) => (
    <div className="banner-container"
        style={{backgroundImage: `url(${image})`, backgroundPosition: `${position}`}}
    >
        <h1>
            {text}
        </h1>
    </div>
)
export default Banner;